import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { motion, AnimatePresence } from 'framer-motion';

const { FiPlus, FiSearch, FiUser, FiFolder, FiLayers, FiZap, FiClock, FiTarget, FiAlertTriangle } = FiIcons;

const QuickActions = () => {
  const [isOpen, setIsOpen] = useState(false);

  const quickActions = [
    {
      id: 'new-case',
      name: 'New Employee Case',
      description: 'Start disciplinary or grievance case',
      path: '/cases',
      action: 'create',
      icon: FiFolder,
      color: 'bg-emerald-500 hover:bg-emerald-600'
    },
    {
      id: 'add-staff',
      name: 'Add Staff Member',
      description: 'Register new employee',
      path: '/staff',
      action: 'create',
      icon: FiUser,
      color: 'bg-purple-500 hover:bg-purple-600'
    },
    {
      id: 'new-workflow',
      name: 'Create Workflow',
      description: 'Start company process',
      path: '/company-workflows',
      action: 'create',
      icon: FiLayers,
      color: 'bg-blue-500 hover:bg-blue-600'
    },
    {
      id: 'search-staff',
      name: 'Search Staff',
      description: 'Find employee quickly',
      path: '/staff',
      action: 'search',
      icon: FiSearch,
      color: 'bg-orange-500 hover:bg-orange-600'
    }
  ];

  const recentItems = [
    {
      type: 'case',
      name: 'Sarah Johnson - Disciplinary',
      path: '/case/CASE-123',
      time: '2 hours ago',
      status: 'active'
    },
    {
      type: 'workflow',
      name: 'Q1 Marketing Recruitment',
      path: '/workflow/WF-456',
      time: '1 day ago',
      status: 'planning'
    },
    {
      type: 'staff',
      name: 'James Smith Profile',
      path: '/staff?filter=EMP002',
      time: '3 days ago',
      status: 'viewed'
    }
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Quick Actions Menu */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.8, y: 20 }}
            className="mb-4 bg-white rounded-lg shadow-xl border border-gray-200 p-4 w-80"
          >
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Quick Actions</h3>
              <div className="grid grid-cols-2 gap-3">
                {quickActions.map((action) => (
                  <Link
                    key={action.id}
                    to={action.path}
                    state={{ action: action.action }}
                    onClick={() => setIsOpen(false)}
                    className={`${action.color} text-white p-3 rounded-lg transition-colors group`}
                  >
                    <div className="flex items-center space-x-2 mb-2">
                      <SafeIcon icon={action.icon} className="text-lg" />
                      <span className="font-medium text-sm">{action.name}</span>
                    </div>
                    <p className="text-xs opacity-90">{action.description}</p>
                  </Link>
                ))}
              </div>
            </div>

            <div className="border-t border-gray-200 pt-4">
              <h4 className="text-sm font-medium text-gray-700 mb-3">Recent Activity</h4>
              <div className="space-y-2">
                {recentItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className="flex items-center justify-between p-2 rounded hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex items-center space-x-2">
                      <div
                        className={`w-2 h-2 rounded-full ${
                          item.status === 'active'
                            ? 'bg-green-500'
                            : item.status === 'planning'
                            ? 'bg-yellow-500'
                            : 'bg-gray-400'
                        }`}
                      />
                      <div>
                        <p className="text-sm font-medium text-gray-900 truncate">{item.name}</p>
                        <p className="text-xs text-gray-500">{item.time}</p>
                      </div>
                    </div>
                    <SafeIcon icon={FiIcons.FiArrowRight} className="text-gray-400 text-sm" />
                  </Link>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating Action Button */}
      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all ${
          isOpen
            ? 'bg-gray-600 hover:bg-gray-700'
            : 'bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700'
        }`}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <SafeIcon icon={isOpen ? FiIcons.FiX : FiZap} className="text-white text-xl" />
      </motion.button>
    </div>
  );
};

export default QuickActions;